import queryString from 'querystring';
import moment from 'moment';
import CryptoJS from "crypto-js";
import { insideCircle, insidePolygon } from 'geolocation-utils';
import { getPermission, getUserId } from './session';
import {
	RANGE_TYPE_TODATE, RANGE_TYPE_PLANNED, RANGE_TYPE_CUSTOM, RANGE_TYPE_TODAY,
	VIEW_CREW, VIEW_EG, VIEW_PLAN, RANGE_TYPE_YESTERDAY,
	RANGE_TYPE_ABSOLUTE, DISPLAY_DATE_FORMAT2, rangeList, LOAD_TYPE,
	VIEW_CUSTOMER
} from '../constants';
import store from '../store';

export const getMatchParams = (params) => {
	const result = { farmId: 0, id: null };
	if (params.hasOwnProperty('farmId') && typeof params.farmId !== 'undefined')
		result.farmId = params.farmId;

	if (params.hasOwnProperty('id') && typeof params.id !== 'undefined')
		result.id = params.id;

	return { ...params, ...result };
};

export const getQueryParams = (queryStr) => {
	queryStr = (typeof queryStr === 'undefined') ? window.location.search : queryStr;
	const defaultParams = { range: 'today' };
	const parsed = queryString.parse(queryStr.replace('?', ''));
	return { ...defaultParams, ...parsed };
};

export const getQueryString = (obj, queryStr) => {
	queryStr = (typeof queryStr === 'undefined') ? window.location.search : queryStr;
	let parsed = queryStr ? queryString.parse(queryStr.replace('?', '')) : {};
	if (obj) parsed = { ...parsed, ...obj };
	return queryString.stringify(parsed).replace('%3F', '');
};

export const compareArray = (arr1, arr2) => {
	if (arr1.length !== arr2.length) return false;
	let notMatchedCount = 0;
	arr1.forEach(a => {
		arr2.forEach(b => {
			const c = { ...a, ...b };
			if (Object.keys(a).length !== Object.keys(c).length ||
				Object.keys(b).length !== Object.keys(c).length) {
				notMatchedCount++;
			}
		});
	});
	return (notMatchedCount === 0);
};

export const capitalize = (str) => { return str.length > 0 && str.charAt(0).toUpperCase() + str.substring(1); };

export const isUUID = (str) => {
	return (str && str.length >= 12);
};

export const groupBy = key => array => {
	if (!array || !key) return {};
	return array.reduce((objectsByKeyValue, obj) => {
		const value = obj[key];
		objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
		return objectsByKeyValue;
	}, {});
};


export const sortBy = (array, key) => array.sort((a, b) => {
	const lowerA = (a[key] || "").toLowerCase();
	const lowerB = (b[key] || "").toLowerCase();
	return (lowerA > lowerB) ? 1 : ((lowerB > lowerA) ? -1 : 0);
});

export const getNameFromEmail = email => (email ? capitalize(email.replace(/@.*/, "")) : "");

export const parseJSON = str => {
	try {
		return JSON.parse(str);
	} catch (ex) {
		return null;
	}
};

export const getFileType = type => {
	if (type && type.indexOf("/") >= 0) return type.split("/")[0];
	else return type;
};

export const uuid = () => {
	const s4 = () => Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
	return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
		s4() + '-' + s4() + s4() + s4();
};

export const usePermission = (whenNotMatch = false) => {
	const permission = getPermission();
	return (controller, action) => {
		if (permission && permission.hasOwnProperty(controller) && permission[controller].hasOwnProperty(action))
			return permission[controller][action];
		return whenNotMatch;
	};
};

export const isAutomaticLoad = () => {
	const loadType = store.getState().farm.currentFarm.load_type;
	return loadType ? loadType === LOAD_TYPE.AUTOMATIC : false;
};

export const isElasticLoad = () => false;

export const searchWord = (text, word) =>
	text ? (text.trim().toLowerCase().search(word.replace(/[*+?^${}()|[\]\\]/g, '\\$&').trim().toLowerCase()) >= 0) : false;

export const isFarmView = view => (view === VIEW_PLAN);

export const isCrewView = view => (view === VIEW_CREW);

export const isCustomerView = view => (view === VIEW_CUSTOMER);

export const isEGView = view => (view === VIEW_EG);

export const isHistorical = range =>
	([RANGE_TYPE_YESTERDAY, RANGE_TYPE_TODATE, RANGE_TYPE_PLANNED, RANGE_TYPE_CUSTOM].indexOf(range) >= 0);

export const isToday = range => ([RANGE_TYPE_TODAY].indexOf(range) >= 0);

export const isYesterday = range => (RANGE_TYPE_YESTERDAY === range);

export const isCustom = range => (RANGE_TYPE_CUSTOM === range);

export const isPlannedOrTodate = range => ([RANGE_TYPE_TODATE, RANGE_TYPE_PLANNED].indexOf(range) >= 0);

export const isAbsolute = range => (RANGE_TYPE_ABSOLUTE === range);

export const getRangeId = (currentRangeType, prevRangeId) => {
	const rangeType = {
		"today": 1,
		"yesterday": 2,
		"last3days": 3,
		"last5days": 4,
		"thisweek": 5,
		"thismonth": 6,
		"last15days": 7,
		"last30days": 8,
		"last60days": 9,
		"last90days": 10,
		"last6month": 11,
		"last9month": 12,
		"todate": 13,
		"planned": 14,
		"thisYear": 15,
		"absolute": 50
	};

	if (currentRangeType === "absolute") return prevRangeId >= rangeType.absolute ? prevRangeId + 1 : rangeType.absolute;
	else if (rangeType.hasOwnProperty(currentRangeType)) return rangeType[currentRangeType];
	else return prevRangeId;
};

export const isRangeChanged = (prev, current) => {
	/*  const prevRange = !isCustom(prev.range) && !isYesterday(prev.range) && isHistorical(prev.range) ? RANGE_TYPE_TODAY : prev.range;
	 const currentRange = !isCustom(current.range) && !isYesterday(current.range) && isHistorical(current.range) ? RANGE_TYPE_TODAY : current.range;
 
	 if (prevRange === currentRange && currentRange === RANGE_TYPE_CUSTOM) {
			 if (prev.custom.from === current.custom.from &&
					 prev.custom.to === current.custom.to)
					 return false;
	 }
	 else if (prevRange === currentRange) return false;
	 return true; */

	const prevRangeId = [1, 13, 14].indexOf(prev.rangeId) >= 0 ? 1 : prev.rangeId;
	const currentRangeId = [1, 13, 14].indexOf(current.rangeId) >= 0 ? 1 : current.rangeId;
	return (prevRangeId !== currentRangeId);
};

export const getSearchDateRange = (params) => {
	const from = (isCustom(params.range) || isYesterday(params.range)) ? params.custom.from : null;
	const to = (isCustom(params.range) || isYesterday(params.range)) ? params.custom.to : null;
	return { from, to };
};

export const isDeveloper = () => {
	const userId = getUserId();
	return [20, 62, 151, 498, 540, 541, 542].indexOf(userId) >= 0;
};

export const getDateRange = ({ range, custom, customRange, isQuickToggle = false }) => {
	const rangeResponse = {
		name: '',
		range: ''
	};
	const selectedRangeSet = rangeList.filter(e => e.id === customRange);
	if (custom.from && custom.to) {
		const timeFormat = DISPLAY_DATE_FORMAT2;
		let dateRange = moment(custom.from).format(timeFormat);

		if (moment(custom.from).format(timeFormat) === moment(custom.to).format(timeFormat)) {
			dateRange = moment(custom.from).format(timeFormat);
		} else {
			if (isQuickToggle) {
				dateRange = (isAbsolute(customRange) || isCustom(range))
					? `${moment(custom.from).format("DD MMM")} to ${moment(custom.to).format("DD MMM")}`
					: `${moment(custom.from).format("DD MMM")}`;
			} else {
				dateRange = (isAbsolute(customRange) || isCustom(range))
					? `${moment(custom.from).format(timeFormat)} to ${moment(custom.to).format(timeFormat)}`
					: `${moment(custom.from).format(timeFormat)}`;
			}
		}

		if (isAbsolute(customRange)) {
			rangeResponse.name = 'Absolute';
			rangeResponse.range = dateRange;
		}
		else if (isToday(range) || isYesterday(range) || isCustom(range)) {
			rangeResponse.name = selectedRangeSet[0].name;
			rangeResponse.range = dateRange;
		}
		else {
			rangeResponse.name = selectedRangeSet[0].name;
		}
	}
	else rangeResponse.name = (selectedRangeSet && selectedRangeSet[0]) ? selectedRangeSet[0].name : "";

	return rangeResponse;
};

export const distinctKeys = (items, key, isCaseSensitive = true) => {
	return items.reduce((arr, obj) => {
		if (typeof obj[key] === undefined || obj[key] === null || obj[key] === "") return arr;
		const keyName = isCaseSensitive ? obj[key].toString().toLowerCase() : obj[key];
		if (arr.indexOf(keyName) < 0) {
			arr.push(obj[key]);
		}
		return arr;
	}, []);
};

export const GEO_SHAPE_TYPE = {
	LINEARRING: "LinearRing",
	MARKER: "marker",
	CIRCLE: "circle",
	POLYGON: "polygon",
	POLYLINE: "polyline",
	RECTANGLE: "rectangle",
}

export const loadEntity = [
	{
		entity_type_id: 1,
		entityId: 'field_geo_region_uuid',
		entityName: 'field_geo_region_name',
		label: 'Field Region'
	},
	{
		entity_type_id: 2,
		entityId: 'field_geo_shape_uuid',
		entityName: 'field_geo_shape_name',
		label: 'Field Shape'
	},
	{
		entity_type_id: 3,
		entityId: 'crew_uuid',
		entityName: 'crew_name',
		label: 'Crew'
	},
	{
		entity_type_id: 4,
		entityId: 'source_equipment_group_uuid',
		entityName: 'source_equipment_group_name',
		label: 'Harvester'
	},
	{
		entity_type_id: 5,
		entityId: 'source_operator_uuid',
		entityName: 'source_operator_name',
		label: 'Harvester Operator'
	},
	{
		entity_type_id: 6,
		entityId: 'target_equipment_group_uuid',
		entityName: 'target_equipment_group_name',
		label: 'Truck'
	},
	{
		entity_type_id: 7,
		entityId: 'operator_uuid',
		entityName: 'operator_name',
		label: 'Truck Operator'
	},
	{
		entity_type_id: 8,
		entityId: 'anonymous_equipment_group_uuid',
		entityName: 'anonymous_equipment_group_name',
		label: 'Anonymous Truck'
	},
	{
		entity_type_id: 9,
		entityId: 'transload_geo_region_uuid',
		entityName: 'transload_geo_region_name',
		label: 'Transload Region'
	},
	{
		entity_type_id: 10,
		entityId: 'transload_geo_shape_uuid',
		entityName: 'transload_geo_shape_name',
		label: 'Transload Shape'
	},
	{
		entity_type_id: 11,
		entityId: 'transport_equipment_group_uuid',
		entityName: 'transport_equipment_group_name',
		label: 'Transport'
	},
	{
		entity_type_id: 12,
		entityId: 'transport_operator_uuid',
		entityName: 'transport_operator_name',
		label: 'Transport Operator'
	},
	{
		entity_type_id: 13,
		entityId: 'offload_geo_region_uuid',
		entityName: 'offload_geo_region_name',
		label: 'Offload Region'
	},
	{
		entity_type_id: 14,
		entityId: 'offload_geo_shape_uuid',
		entityName: 'offload_geo_shape_name',
		label: 'Offload Shape'
	},
	{
		entity_type_id: 15,
		entityId: 'offload_geo_storage_location_uuid',
		entityName: 'offload_geo_storage_location_name',
		label: 'Storage Location'
	}
];

export const encryptMessage = (message, secretKey) => {
	const key = CryptoJS.enc.Utf8.parse(secretKey);
	const encrypted = CryptoJS.AES.encrypt(message, key, {
		mode: CryptoJS.mode.ECB,
		padding: CryptoJS.pad.Pkcs7
	});
	return encrypted.toString();
}


export const decryptMessage = (encryptedMessage, secretKey) => {
	const key = CryptoJS.enc.Utf8.parse(secretKey);
	const decrypted = CryptoJS.AES.decrypt(encryptedMessage, key, {
		mode: CryptoJS.mode.ECB,
		padding: CryptoJS.pad.Pkcs7
	});
	return decrypted.toString(CryptoJS.enc.Utf8);
}

export const isValidUUID = (uuid) => {
	const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
	return uuidPattern.test(uuid);
}

export const isInsideRegion = (point, region = [], properties) => {
	const { type, radius } = properties;
	let isInside = false;
	switch (type) {
		case "polyline":
			isInside = false
			break;
		case "polygon":
			isInside = insidePolygon(point, region);
			break;
		case "rectangle":
			const polygon = [
				{ lat: region[0].lat, lng: region[0].lng },
				{ lat: region[0].lat, lng: region[1].lng },
				{ lat: region[1].lat, lng: region[1].lng },
				{ lat: region[1].lat, lng: region[0].lng }
			];
			isInside = insidePolygon(point, polygon);
			break;
		case "circle":
			isInside = insideCircle(point, region[0], radius);
			break;
		default:
			isInside = false
	}
	return isInside;
}

export const triggerNavigator = async ({ name, label }) => {
	let results = {}
	const navigatorPromise = await new Promise((resolve) => {
		if (navigator && navigator.permissions) {
			navigator.permissions.query({ name })
				.then(function (result) {
					if (['granted', 'prompt'].includes(result.state)) {
						return resolve(true);
					} else if (result.state === "denied") {
						console.log(`${label} access is denied please turn on`)
					}
				})
				.catch(function (error) {
					console.error(`Error checking ${name} permission:`, error);
					return resolve(false);
				});
		}
	});
	const isGranted = await navigatorPromise;
	if (isGranted) {
		if (name === 'geolocation') {
			const res = await requestNavigator(name);
			results[name] = res;
		}
	}

	return results;
}

export const requestNavigator = async (name) => {
	return await new Promise((resolve) => {
		if (navigator && navigator.geolocation && name === 'geolocation') {
			navigator.geolocation.getCurrentPosition(
				function (position) {
					var lat = position.coords.latitude;
					var lng = position.coords.longitude;
					return resolve({ lat, lng })
				},
				function (error) {
					console.error('Error getting location:', error);
					return resolve({ lat: null, lng: null });
				}
			);
		} else {
			console.error('Geolocation is not supported by this browser.');
			return resolve({ lat: null, lng: null });
		}
	});
}

export const isValidEmail = (email) => {
	const reg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	return reg.test(String(email).toLowerCase());
};

export const blockInvalidChar = e => ['+', '-', '.'].includes(e.key) && e.preventDefault();

export const getCurrentView = () => {
	const location = window.location.pathname;
	const parts = location.split('/');
	const lastPart = parts[parts.length - 1];
	return lastPart;
}

export const getTimeXaxisCategories = () => {
	const times = [];
	const formatHour = (hour) => hour.toString();
	times.push("12 AM");
	for (let i = 1; i < 12; i++) {
		times.push(`${formatHour(i)} AM`);
	}
	times.push("12 PM");
	for (let i = 1; i < 12; i++) {
		times.push(`${formatHour(i)} PM`);
	}
	return times;
};


export const validateCollections = (arr) => {
	return arr && arr.length > 0;
}
export const getDistanceValue = (fieldId, offloadId, dataArray) => {
	const distanceData = dataArray.find(item =>
		item.source_shape_uuid === fieldId && item.destination_shape_uuid === offloadId
	);

	return distanceData ? distanceData.distance_value : 0;
};
export const verifyObjectProperties = (obj, key, baseValue = null) => obj && obj[key] ? obj[key] : baseValue;

export const getTimeDiffrence = (custom, differenceIn = 'hours') => {
	const startDate = (custom && custom.from) ? moment(custom.from) : null;
	const endDate = (custom && custom.to) ? moment(custom.to) : null;
	return (startDate && endDate) ? endDate.diff(startDate, differenceIn) : 0;
};

export const parseToMoment = (dateString) => {
	// Replace space between date and time with 'T' to create an ISO string
	if (dateString && dateString.indexOf(" ") !== -1) {
		dateString = dateString.replace(" ", "T");
	}
	// Parse the date and ensure it handles the timezone if necessary
	return moment(dateString).isValid() ? moment(dateString) : null;  // Returns a Moment object or null if invalid
}